import classNames from "classnames"

type StepProgressProps = {
  currentStep: number
  totalSteps: number
  trackClassName?: string
}

const StepProgress = ({
  currentStep,
  totalSteps,
  trackClassName = "bg-[#1A1D21]"
}: StepProgressProps) => (
  <div className="flex flex-col gap-2">
    <p className="text-xs tracking-[-0.01em] text-[#9CA3AF]">
      Step {currentStep} of {totalSteps}
    </p>
    <div
      className="flex items-center gap-1"
      role="progressbar"
      aria-valuenow={currentStep}
      aria-valuemin={1}
      aria-valuemax={totalSteps}
      aria-label={`Step ${currentStep} of ${totalSteps}`}
    >
      {Array.from({ length: totalSteps }, (_, index) => (
        <span
          key={index}
          className={classNames(
            "h-1 w-12",
            index < currentStep ? "bg-[#2D3036]" : trackClassName
          )}
        />
      ))}
    </div>
  </div>
)

export default StepProgress
